/* eslint-disable @typescript-eslint/no-explicit-any */
import { put, call, takeLatest, all } from 'redux-saga/effects';
import Cookie from 'js-cookie';
import { authRequest, authLogin, authFailure, authLogout } from './slice';
import Requests from '@/Services/Requests';
import {
  COOKIE_TOKEN_KEY,
  KEY_QL_MANAGER_SELECTED_CITY,
  LOCALSTORAGE_URL_API_KEY,
  USER_KEY,
} from '@/_constants/keys';
import { setBearerToken } from '@/_config/lib/axios/api-client-old';
import { queryClient } from '@/_config/lib/react-query/query-client';
import { GET_MOTOBOYS_LIST } from '@/_features/motoboys/motoboy-list/constants';
import { configureSentryScope } from '@/_config/lib/sentry';
import { normalizeMunicipioIds } from '@/_utils/normalize-municipio-ids';

interface LoginResponse {
  r: boolean;
  data: any;
  errors: string[];
}

function buildUserFromLoginData(data: any) {
  const userData = { ...data };
  delete userData.token;

  userData.municipioIds = normalizeMunicipioIds(data.municipioIds);

  return userData;
}

function* setAuth(action: any) {
  if (action.payload) {
    const { login, password } = action.payload;

    try {
      const response: LoginResponse = yield call(
        Requests.manager.login,
        login,
        password,
      );

      if (response.r) {
        const user = buildUserFromLoginData(response.data);

        yield setBearerToken(response.data.token);
        yield put(
          authLogin({
            token: response.data.token,
            user,
          }),
        );

        queryClient.invalidateQueries([GET_MOTOBOYS_LIST]);

        yield Cookie.set(COOKIE_TOKEN_KEY, response.data.token, {
          sameSite: 'Strict',
          secure: true,
        });

        yield localStorage.setItem(USER_KEY, JSON.stringify(user));
      } else {
        yield put(authFailure([...response.errors] as any));
      }
    } catch (err: any) {
      const errorMessage = err.response?.data.error;
      yield put(authFailure([errorMessage] as any));
    }
  }
}

function* logout() {
  yield Cookie.remove(COOKIE_TOKEN_KEY);
  yield localStorage.removeItem(USER_KEY);
  yield localStorage.removeItem(KEY_QL_MANAGER_SELECTED_CITY);
  yield localStorage.removeItem(LOCALSTORAGE_URL_API_KEY);
}

function configureUserScope(action: any) {
  const { payload } = action;
  if (payload.user) {
    configureSentryScope(payload.user);
  }
}

export default all([
  takeLatest(authRequest.type, setAuth),
  takeLatest(authLogout.type, logout),
  takeLatest(authLogin.type, configureUserScope),
]);
